// @flow

import React, { Component } from 'react';
import { FacebookIcon } from 'seek-style-guide/react';
import { hrefFromLocation } from '@seek/seek-jobs-seo/build/location';
import ShareButton from '../ShareButton/ShareButton';

function facebookUrl(location) {
  const returnUrl = hrefFromLocation({
    ...location,
    query: {
      ...location.query,
      share: 'fb'
    }
  });

  return hrefFromLocation({
    protocol: 'https:',
    hostname: 'www.facebook.com',
    pathname: '/sharer.php',
    query: {
      u: returnUrl
    }
  });
}

type Props = {
  location: UrlLocation
};

export default class FacebookButton extends Component<Props> {
  props: Props;

  render() {
    return (
      <ShareButton
        title="Share on Facebook"
        type="facebook"
        icon={FacebookIcon}
        href={facebookUrl(this.props.location)}
        popupWidth={620}
        popupHeight={436}
      />
    );
  }
}
